/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */
import { createReducer } from 'reduxsauce';
import { InbOrd04Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const inbOrd04ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
});

export const inbOrd04FetchInbOrd04Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const inbOrd04FetchInbOrd04Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const inbOrd04AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const inbOrd04RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const inbOrd04SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const inbOrd04CreateInbOrd04Loading = (state, { boolean }) => ({
  ...state,
  createIsLoading: boolean
});

export const inbOrd04CreateInbOrd04Success = (state, { newDocuments }) => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: [],
  newDocuments
});

export const inbOrd04SetExpandedRows = (state, { expandedRows }) => ({
  ...state,
  expandedRows
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [InbOrd04Types.INB_ORD04_RESET_TIMESTAMP]: inbOrd04ResetTimestamp,
  [InbOrd04Types.INB_ORD04_FETCH_INB_ORD04_LOADING]: inbOrd04FetchInbOrd04Loading,
  [InbOrd04Types.INB_ORD04_FETCH_INB_ORD04_SUCCESS]: inbOrd04FetchInbOrd04Success,
  [InbOrd04Types.INB_ORD04_ADD_SELECTED_DOCUMENTS]: inbOrd04AddSelectedDocuments,
  [InbOrd04Types.INB_ORD04_REMOVE_SELECTED_DOCUMENTS]: inbOrd04RemoveSelectedDocuments,
  [InbOrd04Types.INB_ORD04_SET_WORKSPACE_VISIBLE]: inbOrd04SetWorkspaceVisible,
  [InbOrd04Types.INB_ORD04_CREATE_INB_ORD04_LOADING]: inbOrd04CreateInbOrd04Loading,
  [InbOrd04Types.INB_ORD04_CREATE_INB_ORD04_SUCCESS]: inbOrd04CreateInbOrd04Success,
  [InbOrd04Types.INB_ORD04_SET_EXPANDED_ROWS]: inbOrd04SetExpandedRows
});
